import { HttpApiService } from "@/shared/services/httpApi.service";
import type { StepUpState } from "@/shared/types/user.entity";

interface SetEmailBackupBody {
  enabled: boolean;
  current_password: string;
}

/**
 * The caller's own email backup for step-up actions (coloca-nest `POST /auth/step-up/email-backup`): on or
 * off, always with the account password. Answers the new step-up state, which the auth slice merges into the
 * user.
 */
export const StepUpEmailBackupService = {
  set: async (body: SetEmailBackupBody): Promise<StepUpState> => {
    const response = await HttpApiService.post<StepUpState, SetEmailBackupBody>(
      "/auth/step-up/email-backup",
      body,
    );
    return response.data;
  },
};
